// extracted by mini-css-extract-plugin
export var typingIndicator = "_px-0";